import React from "react";
import {
  Box,
  Button,
  Typography,
  Pagination,
  CircularProgress,
} from "@mui/material";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";

const PaginationComponent = ({
  currentPage,
  totalPages,
  totalCount,
  perPage,
  onPageChange,
  loading = false,
  prevEnable,
  nextEnable,
}) => {
  const startItem = (currentPage - 1) * perPage + 1;
  const endItem = Math.min(currentPage * perPage, totalCount);

  const handlePageChange = (event, page) => {
    if (page !== currentPage && !loading) {
      onPageChange(page);
    }
  };

  const handlePrevPage = () => {
    if (prevEnable && currentPage > 1 && !loading) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (nextEnable && currentPage < totalPages && !loading) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "32px",
        padding: "16px 0",
        borderTop: "1px solid #e0e0e0",
      }}
    >
      {/* Results Info */}
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {loading ? (
          <CircularProgress size={16} />
        ) : (
          <Typography variant="body2" sx={{ color: "#666" }}>
            Showing {startItem}-{endItem} of {totalCount} rooms
          </Typography>
        )}
      </Box>

      {/* Pagination Controls */}
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {/* Previous Button */}
        <Button
          variant="outlined"
          onClick={handlePrevPage}
          disabled={!prevEnable || currentPage === 1 || loading}
          sx={{
            minWidth: "auto",
            padding: "6px 12px",
            borderRadius: "6px",
            borderColor: "#d0d0d0",
            color: "#666",
            textTransform: "none",
            "&:hover": {
              borderColor: "#4d6bf6",
              color: "#4d6bf6",
            },
            "&.Mui-disabled": {
              borderColor: "#e0e0e0",
              color: "#ccc",
            },
          }}
        >
          <KeyboardArrowLeft />
        </Button>

        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          disabled={loading}
          hidePrevButton
          hideNextButton
          size="small"
          sx={{
            "& .MuiPaginationItem-root": {
              borderRadius: "6px",
              border: "1px solid #d0d0d0",
              margin: "0 2px",
              minWidth: "32px",
              height: "32px",
              "&.Mui-selected": {
                backgroundColor: "#4d6bf6",
                color: "white",
                borderColor: "#4d6bf6",
                "&:hover": {
                  backgroundColor: "#1565c0",
                },
              },
              "&:hover": {
                borderColor: "#4d6bf6",
                color: "#4d6bf6",
              },
            },
          }}
        />

        <Button
          variant="outlined"
          onClick={handleNextPage}
          disabled={!nextEnable || currentPage === totalPages || loading}
          sx={{
            minWidth: "auto",
            padding: "6px 12px",
            borderRadius: "6px",
            borderColor: "#d0d0d0",
            color: "#666",
            textTransform: "none",
            "&:hover": {
              borderColor: "#4d6bf6",
              color: "#4d6bf6",
            },
            "&.Mui-disabled": {
              borderColor: "#e0e0e0",
              color: "#ccc",
            },
          }}
        >
          <KeyboardArrowRight />
        </Button>
      </Box>
    </Box>
  );
};

export default PaginationComponent;
